import script from "./MatchScoreTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchScoreTable.vue?vue&type=script&setup=true&lang=js"

import "./MatchScoreTable.vue?vue&type=style&index=0&id=079ae574&lang=css"

const __exports__ = script;

export default __exports__